export enum ApplyStatus {
  ALL = "",
  ACCEPTED = "승인",
  APPLIED = "신청",
  RETURNED = "반려",
}

export enum DeviceType {
  IOS = "ios",
  ANDROID = "android",
}

export enum InquiryStatus {
  ALL = "",
  RECEIVED = "received",
  PENDING = "pending",
  REPLIED = "replied",
}

export enum Service {
  ALL = "",
  CUSTOMER_APP = "CUSTOMER_APP",
  BOS_WEB = "BOS_WEB",
  REPAIR_SHOP_WEB = "REPAIR_SHOP_WEB",
}

export enum CatalogType {
  ALL = "",
  TIRE = "TIRE",
  BAT = "BAT",
  EOIL = "EOIL",
  WASH = "WASH",
  PARTS = "PARTS",
  ETC = "ETC",
}
export enum ProductType {
  ALL = "",
  SINGLE = "SINGLE",
  MULTIPLE = "MULTIPLE",
  TIRE = "TIRE",
  BAT = "BAT",
  EOIL = "EOIL",
  WASH = "WASH",
  PARTS = "PARTS",
  ETC = "ETC",
}
export enum Badge {
  ALL = "",
  GREAT = "우수",
  NORMAL = "보통",
  BAD = "미흡",
}
export enum CatalogGroupType {
  ENGINE_OIL,
  TIRE,
  BATTERY,
}

export enum StockStatus {
  ALL = "",
  WAITING = "WAITING",
  ACTIVE = "ACTIVE",
  ORDER_PICKING = "ORDER_PICKING",
  DELIVERY = "DELIVERY",
  SOLD_OUT = "SOLD_OUT",
  RETURN = "RETURN",
  NOT_AVAILABLE = "NOT_AVAILABLE",
}

export const DefaultType = {
  ALL: "",
};
export enum TerminalType {
  ALL = "",
  STD = "STD",
  SMALL = "Small",
}
export enum TerminalPosition {
  ALL = "",
  L = "LEFT",
  R = "RIGHT",
}
export enum TaxType {
  TAX = "TAX",
  TAX_ZERO = "TAX_ZERO",
  TAX_FREE = "TAX_FREE",
}
export enum PaymentType {
  VIRTUAL_ACCOUNT = "VIRTUAL_ACCOUNT",
  CREDIT_CARD = "CREDIT_CARD",
}
export enum AdministratorStatus {
  ALL = "",
  ACTIVATION = "activation",
  DORMANCY = "dormancy",
}
export enum ProductPaymentType {
  VIRTUAL_ACCOUNT = "VIRTUAL_ACCOUNT",
  KAKAO = "KAKAO_PAY",
  NAVER = "NAVER_PAY",
  CARD = "CREDIT_CARD",
  TOSS = "TOSS_PAY",
}
export enum ProductBadge {
  BEST = "BEST",
  HOT = "HOT",
  NEW = "NEW",
}
export enum DeliverytemplatePaymetType {
  CASH_ON_DELIVERY = "CASH_ON_DELIVERY",
  PREPAYMANT = "PREPAYMANT",
  SELECT = "SELECT",
}
export enum DispatchTemplateType {
  ALL = "",
  EMAIL = "EMAIL",
  MESSAGE = "MESSAGE",
  PUSH = "PUSH",
}
export enum TemporaryBusinessType {
  CHANGED = "CHANGED",
  CLOSED = "CLOSED",
}
export enum DayOffWeek {
  ONE = 1,
  TWO,
  THREE,
  FOUR,
  FIVE,
  EVERY_WEEK = "EVERY_WEEK",
}
export enum DayOffDay {
  SUNDAY = "SUNDAY",
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  HOLIDAY = "HOLIDAY",
}
export enum ReservationInterval {
  THIRTY = 30,
  SIXTY = 60,
  NINETY = 90,
  ONEHUNDREDTWENTY = 120,
  ONEHUNDREDFIFTY = 150,
  ONEHUNDREDEIGHTY = 180,
}

export enum RestDayType {
  Weekend,
  Week,
  Holiday,
}
export enum RoutineType {
  EVERY_WEEK,
  NOT_EVERY_WEEK,
}
export enum BusinessDayType {
  EVERYDAY = "EVERYDAY",
  WEEKDAY_WEEKEND = "WEEKDAY WEEKEND",
  DAY = "DAY",
}
export enum RepairShopSortType {
  ALL = "ALL",
  NORMAL = "NORMAL",
  WARNING = "WARNING",
}
export enum RepairShopMediaType {
  ALL = "전체",
  FRONT = "정면",
  IN = "내부",
}
export enum WheelAlignmentTaxType {
  TAX = "TAX",
  TAX_ZERO = "TAX_ZERO",
  TAX_FREE = "TAX_FREE",
}
export enum RepairStatus {
  COMPLETED = "COMPLETED",
  RESERVATION_COMPLETED = "RESERVATION_COMPLETED",
  PAYMENT_COMPLETED = "PAYMENT_COMPLETED",
}
export enum OrderChannels {
  TIREPICK = "TIREPICK",
  ELEVEN_ST = "ELEVEN_ST",
  WE_MAKE_PRICE = "WE_MAKE_PRICE",
  SMART_STORE = "SMART_STORE",
  INTER_PARK = "INTER_PARK",
  GMARKET = "GMARKET",
  COUPANG = "COUPANG",
  AUCTION = "AUCTION",
}
export enum RepairStatuses {
  PENDING = "PENDING",
  COMPLETED_PAYMENT = "COMPLETED_PAYMENT",
  RESERVED = "RESERVED",
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
}

export enum PartnerBosRepairStatuses {
  PAYMENT_COMPLETED = "PAYMENT_COMPLETED", // 결제완료
  RESERVATION_COMPLETED = "RESERVATION_COMPLETED", // 예약완료
  COMPLETED = "COMPLETED", // 작업완료
  CANCELED_ORDER = "CANCELED_ORDER",
}

export enum GoodsIssueStatuses {
  REQUESTED_GOODS_ISSUE = "REQUESTED_GOODS_ISSUE", // 출고요청
  REQUEST_CHECKED_GOODS_ISSUE = "REQUEST_CHECKED_GOODS_ISSUE", // 출고요청확인
  CANCELED_GOODS_ISSUE = "CANCELED_GOODS_ISSUE", // 출고요청취소
  CONFIRMED_GOODS_ISSUE = "CONFIRMED_GOODS_ISSUE", // 출고확정
}
export enum OrderServiceTypes {
  TIRE_REPAIR = "TIRE_REPAIR",
  TIRE_DELIVERY = "TIRE_DELIVERY",
  BATTERY_RUSH = "BATTERY_RUSH",
  VEHICLE_WASH = "VEHICLE_WASH",
}
export enum OrderItemStatuses {
  PENDING = "PENDING",
  READIED_PAYMENT = "READIED_PAYMENT",
  CONFIRMED_ORDER = "CONFIRMED_ORDER",
  COMPLETED_PAYMENT = "COMPLETED_PAYMENT",
  REQUEST_GOODS_ISSUE = "REQUESTED_GOODS_ISSUE",
  COMPLETED_GOODS_ISSUE = "COMPLETED_GOODS_ISSUE",
  COMPLETED_DELIVERY = "COMPLETED_DELIVERY",
  CONFIRMED_PURCHASE = "CONFIRMED_PURCHASE",
  CANCELED_ORDER = "CANCELED_ORDER",
}
export enum OrderItemReturnStatuses {
  REQUESTED_RETURN = "REQUESTED_RETURN",
  CONFIRMED_RETURN = "CONFIRMED_RETURN",
  COMPLETED_RETURN = "COMPLETED_RETURN",
}
export enum DeliveryHistoryStatuses {
  READY = "READY",
  COLLECTION = "COLLECTION",
  TRACKING = "TRACKING",
  ARRIVE_POINT = "ARRIVE_POINT",
  DELIVERY = "DELIVERY",
  COMPLETE = "COMPLETE",
}
